<template>
    
    <DataTable ref="dt" 
        :value="items.data" dataKey="id" 
        :totalRecords="items.total"
        :sortField="sort" :sortOrder="sortOrder"
        :paginator="true" :rows="rows" :alwaysShowPaginator="false" :filters="filters"
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport"
        currentPageReportTemplate="{first}-{last} of {totalRecords}" responsiveLayout="scroll"
        :lazy="true" :loading="loading" @page="onPage($event)" @sort="onSort($event)" @filter="onFilter($event)" @rowClick="onrowclick"
    >
        
        <template #header v-if="showHeader">
            <div class='row justify-content-between' id="overview-header">
                <div :class="('w-' + (pushLeft ? '25' : '50'))">
                    <h2 class="pt-1 pb-3">{{moduleNamePlural}}</h2>
                </div>
                <div :class="('d-flex w-' + (pushLeft ? '75 gap-2' : '50'))">
                    <div class="form-group search" :style="{width: (pushLeft ? '50%' : '100%')}">
                        <i class="fa fa-search" aria-hidden="true"></i>
                        <input type="search" class="form-control" id="search" :placeholder="$t('overview.search')" @change="onChange()" @input="onInput()" @keypress.enter.prevent="onEnter()" v-model="filters['global'].value" autocomplete="off">
                    </div>
                    <div v-if="pushLeft" class="d-flex gap-2" :style="{marginRight: '170px', width: '50%'}">
                        <input class="form-control header-field" v-model="dateFrom" @change="onDateChange()" placeholder="Vanaf" @focus="setDatePickerActive" @blur="setDatePickerInctive">
                        <input class="form-control header-field" v-model="dateTo" @change="onDateChange()" placeholder="t.m." @focus="setDatePickerActive" @blur="setDatePickerInctive">
                    </div>
                    <button class="btn w-auto h-auto collapsed ms-4" style="margin-right: 19px" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne" v-if="filterGroups">
                        <i class="fa fa-bars-filter"></i>
                    </button>
                </div>
            </div>

            <div id="collapseOne" class="accordion-collapse collapse" aria-labelledby="headingOne" data-bs-parent="#overview-header" v-if="filterGroups">
                <div class="accordion-body ps-0">
                    <template v-for="filtergroup in filterGroups" :key="filtergroup.name">
                        <div class="d-flex gap-5 mb-3">
                            <label :for="'filter-'+filtergroup.field+'-all'" class="inputgroup col-auto">
                                <input :type="filtergroup.type" :name="'filter-'+filtergroup.name"  :id="'filter-'+filtergroup.field+'-all'" checked="" @click="setExtrafilters(filtergroup, 'all')" />
                                <span>Alle {{filtergroup.name}}</span>
                            </label>
                            <template v-for="filter in filtergroup.values" :key="filter.id">
                                <label :for="'filter-'+filtergroup.name+'_'+filter.id" class="inputgroup col-auto">
                                    <input :type="filtergroup.type" :name="'filter-'+filtergroup.name" :id="'filter-'+filtergroup.name+'_'+filter.id" @click="setExtrafilters(filtergroup, filter.id)" :data-field="filtergroup.field" />
                                    <span>{{filter.name}}</span>
                                </label>
                            </template>
                        </div>
                    </template>
                </div>
            </div>
            
        </template>

        <slot name="columns"></slot>
        <slot name="actionscolumn">
            <Column header="" :exportable="false" style="width:90px">
                <template #body="slotProps">
                    <div :class="showDropdown ? 'dropdown d-inline' : 'd-none'">
                        <button type="button" id="dropdownMenuButton1" class="btn dropdownmenubtn" data-bs-toggle="dropdown" aria-expanded="false"><i class="fa-light fa-ellipsis-vertical px-2"></i></button>
                        <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuButton1">
                            <template v-if="(slotProps.data.contract || slotProps.data.employee_id) && slotProps.data.employee_status">
                                <template v-if="slotProps.data.contract && slotProps.data.employee_status.name == 'in afwachting van gegevens'"> <!-- In afwachting gegevens -->
                                    <li>
                                        <a class="dropdown-item" @click="setHref(0, slotProps.data)">
                                            <i class="fal fa-pen"></i> {{ $t('overview.changecontract') }}
                                        </a>
                                    </li>
                                    <li>
                                        <a class="dropdown-item" data-bs-toggle="modal" data-bs-target="#formModal" @click="editItem(slotProps.data, true, 'reminder')">
                                            <i class="fal fa-envelope"></i> {{ $t('overview.rem_mail') }}
                                        </a>
                                    </li>
                                </template>
                                <li v-if="slotProps.data.employee_status && (slotProps.data.employee_status.name == 'in dienst' || slotProps.data.employee_status.name == 'in afwachting van gegevens')"> <!-- NAW-gegevens -->
                                    <a class="dropdown-item" @click="setHref(1, slotProps.data)">
                                        <i class="fal fa-pen"></i> {{ $t('overview.employee_action_1' + (slotProps.data.employee_status_id == 1 ? 'b' : 'a')) }}
                                    </a>
                                </li>
                                <template v-if="slotProps.data.employee_status && slotProps.data.employee_status.name.includes('ondertekenen contract')"> <!-- In afwachting ondertekening -->
                                    <!--<li>
                                        <a class="dropdown-item" @click="setHref(!slotProps.data.contract ? 2 : 0, slotProps.data)">
                                            <i class="fal fa-pen"></i> {{ $t('overview.employee_action_2a') }}
                                        </a>
                                    </li>-->
                                    <li>
                                        <a class="dropdown-item" @click="setHref(0, slotProps.data)">
                                            <i class="fal fa-pen"></i> {{ $t('overview.changecontract') }}
                                        </a>
                                    </li>
                                    <li v-if="isHR">
                                        <a class="dropdown-item" @click="sync(slotProps.data)">
                                            <i class="fal fa-sync"></i> Synchroniseer met NMBRS
                                        </a>
                                    </li>
                                    <li>
                                        <a class="dropdown-item" @click="sendSignRequest(slotProps.data)">
                                            <i class="fal fa-send"></i> {{ $t('overview.employee_action_5') }}
                                        </a>
                                    </li>
                                    <li>
                                        <a class="dropdown-item" data-bs-toggle="modal" data-bs-target="#formModal" @click="editItem(slotProps.data, true, 'wontbeemployed')">
                                            <i class="fal fa-envelope"></i> {{ $t('overview.employee_action_6a') }}
                                        </a>
                                    </li>
                                    <li>
                                        <a class="dropdown-item" @click="sendFinalizationRequest(slotProps.data)">
                                            <i class="fal fa-clipboard-check"></i> {{ $t('overview.employee_action_7') }}
                                        </a>
                                    </li>
                                </template>
                                <template v-if="slotProps.data.employee_status.name == 'contract afgekeurd'"> <!-- Contract afgekeurd -->
                                    <li>
                                        <a class="dropdown-item" @click="setHref(!slotProps.data.contract ? 2 : 0, slotProps.data)">
                                            <i class="fal fa-pen"></i> {{ $t('overview.employee_action_2a') }}
                                        </a>
                                    </li>
                                    <li>
                                        <a class="dropdown-item" @click="setHref(5, slotProps.data)">
                                            <i class="fal fa-pen"></i> {{ $t('overview.employee_action_1b') }}
                                        </a>
                                    </li>
                                    <li v-if="slotProps.data.employed_since">
                                        <a class="dropdown-item" data-bs-toggle="modal" data-bs-target="#contractChangeOptionsModal" @click="setSavedData(slotProps.data)">
                                            <i class="fal fa-pen"></i> {{ $t('overview.employee_action_2b') }}
                                        </a>
                                    </li>
                                    <li>
                                        <a class="dropdown-item" data-bs-toggle="modal" data-bs-target="#formModal" @click="editItem(slotProps.data, true, 'wontbeemployed')">
                                            <i class="fal fa-envelope"></i> {{ $t('overview.employee_action_6a') }}
                                        </a>
                                    </li>
                                </template>
                                <template v-if="slotProps.data.employee_status.name == 'in dienst'"> <!-- In dienst -->
                                    <li>
                                        <a class="dropdown-item" data-bs-toggle="modal" data-bs-target="#contractChangeOptionsModal" @click="setSavedData(slotProps.data)">
                                            <i class="fal fa-pen"></i> {{ $t('overview.employee_action_2b') }}
                                        </a>
                                    </li>
                                    <li>
                                        <a class="dropdown-item" data-bs-toggle="modal" @click="setHref(7, slotProps.data)">
                                            <i class="fal fa-envelope"></i> {{ $t('overview.employee_action_6b') }}
                                        </a>
                                    </li>
                                    <li>
                                        <a class="dropdown-item" data-bs-toggle="modal" data-bs-target="#formModal" @click="editItem(slotProps.data, true)">
                                            <i class="fal fa-envelope"></i> {{ $t('overview.employee_action_6') }}
                                        </a>
                                    </li>
                                </template>
                                <li v-if="slotProps.data.contract">
                                    <a class="dropdown-item" @click="$router.push({ name: 'show_employee_main', params: { id: slotProps.data.contract.id } })">
                                        <i class="fal fa-memo"></i> {{ $t('overview.employee_details') }}
                                    </a>
                                </li>
                                <li>
                                    <a class="dropdown-item" @click="$router.push({ name: 'show_employee_audit', params: { id: slotProps.data.employee_id ? slotProps.data.employee_id : slotProps.data.external_id } })">
                                        <i class="fal fa-user-magnifying-glass"></i> {{ $t('overview.employee_revise') }}
                                    </a>
                                </li>
                            </template>
                            <template v-else>
                                <li>
                                    <a class="dropdown-item text-warning" data-bs-toggle="modal" data-bs-target="#formModal" @click="editItem(slotProps.data)">
                                        <i class="fal fa-pen"></i> {{ $t('overview.edit') }}
                                    </a>
                                </li>
                                <li>
                                    <a class="dropdown-item text-success" v-if="showDownload" @click="downloadPDF(slotProps.data)">
                                        <i class="fal fa-download"></i> Download {{ $t('overview.download_pdf') }}
                                    </a>
                                </li>
                                <li>
                                    <a class="dropdown-item text-info" v-if="showCopy" data-bs-toggle="modal" data-bs-target="#formModal" @click="copyItem(slotProps.data)">
                                        <i class="fal fa-copy"></i> {{ $t('overview.copy') }}
                                    </a>
                                </li>
                                <li>
                                    <a class="dropdown-item text-danger" data-bs-toggle="modal" data-bs-target="#deleteModal" @click="delItem(slotProps.data)">
                                        <i class="fal fa-trash-alt"></i> {{ $t('overview.delete') }}
                                    </a>
                                </li>
                            </template>
                            <template v-if="(slotProps.data.contract || slotProps.data.employee_id) && slotProps.data.employee_status && slotProps.data.contract && slotProps.data.employee_status.name == 'in afwachting van gegevens'"> <!-- In afwachting gegevens -->
                                <li>
                                    <a class="dropdown-item text-danger" data-bs-toggle="modal" data-bs-target="#deleteModal" @click="delItem(slotProps.data, true)">
                                        <i class="fal fa-trash-alt"></i> {{ $t('overview.delete') }}
                                    </a>
                                </li>
                            </template>
                        </ul>
                        
                    </div>
                    
                </template>
            </Column>
        </slot>
    </DataTable>

    <FormPopup v-on:save="save" v-on:del="del" :itemId="item ? item.id : null" :itemName="item ? (item.employee_name ? item.employee_name : item[sort]) : null" :moduleName="moduleName" :loading="itemLoading" 
              :modalSize="modalSize" :modalHeight="modalHeight" :modalWidth="modalWidth" :isCopy="isCopying" :isMail="isMail" :bezig="isSaving || isDeleting">
        <slot name='form'></slot>
        <template #modal-footer><slot name="modal-footer"></slot></template>
    </FormPopup>

    <div class="modal fade" id="contractChangeOptionsModal" tabindex="-1" aria-labelledby="contractChangeOptionsModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="contractChangeOptionsModalLabel">{{$t('overview.change') + ' ' + $t('navigation.employees')}}</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-footer d-block">
                    <button type="button" class="btn d-block w-100 btn-primary" data-bs-dismiss="modal" @click="setHref(0, savedData, true)">Nieuw contract genereren</button>
                    <button type="button" class="btn d-block w-100 mt-2 btn-primary" data-bs-dismiss="modal" @click="setHref(2, savedData)">Tussentijdse wijziging</button>
                    <button type="button" class="btn d-block w-100 mt-2 btn-primary" data-bs-dismiss="modal" @click="setHref(6, savedData)" v-if="savedData && !(savedData.contract && savedData.contract.job_function && savedData.contract.job_function.fixed_term == 0)">{{ $t('overview.employee_action_2c') }}</button>
                </div>
            </div>
        </div>
    </div>

    <div class="d-none" @click="downloadTestPDF">_</div>
    
</template>

<script>
import { FilterMatchMode } from 'primevue/api';
import DataTable from '@/components/DataTable.vue';
import Column from 'primevue/column';
import FormPopup from '@/components/FormPopup.vue';
import moment from 'moment';
import router from '@/router';
import store from '@/store/user';
import employeeService from '@/services/EmployeeService';
import { sleutelVoorAfrondenBuitenSysteem, queryVoorNawWijziging } from '@/logic/overzicht';
import { metRem } from '@/logic/rem';
import { alsHtml } from '@/logic/foutmelding';

export default {
    name: 'Overview',
    props: {
        'moduleNamePlural': {},
        'moduleName': {},
        'sort': {},
        'sortOrder': { type: Number, default: 1},
        'itemService': {},
        'itemFormRef': {},
        'modalSize': {},
        'modalHeight': {},
        'modalWidth': {},
        'showDownload': { type: Boolean, default: false},
        'showCopy': { type: Boolean, default: false},
        'showDropdown': { type: Boolean, default: true},
        'showHeader': { type: Boolean, default: true},
        'pushLeft': { type: Boolean, default: false},
        'filterNMBRS': { type: Boolean, default: true},
        'filterGroups': [],
        'rows': { type: Number, default: 20},
    },
    components: {
        DataTable,
        Column,
        FormPopup
    },
    emits: 'refreshList',
    data() {
        return {
            items: {
                'data': [],
                'total': 0
            },
            loading: true,
            lazyParams: {},
            page: 1,
            filters: {},
            pageNumber: 1,
            extraFilters: {},
            prevFilterValue: '',
            
            item: {},
            itemLoading: false,
            isCopying: false,
            isMail: false,
            // De remmen tegen dubbel klikken, een per schrijfactie. Ze gaan erop
            // in metRem() en er weer af zodra het antwoord binnen is, ook bij een
            // fout. Zie logic/rem.js.
            isSaving: false,
            isDeleting: false,
            isSyncing: false,
            isSendingSignRequest: false,
            isFinalizing: false,
            dateFrom: null,
            dateTo: null
        }
    },
    computed: {
        isHR() {
            return store.getters.getIsHR;
        }
    },
    methods: {
        onPage(event) {
            this.page = event.page + 1
            this.getIndex();
        },
        onSort(event) {
            this.page = 1;
            this.lazyParams = event;
            this.lazyParams.route = this.$route.name
            this.getIndex();
        },
        onFilter() {
            this.lazyParams.filters = this.filters;
            this.getIndex();
        },
        onChange(){
            if(!this.loading && this.prevFilterValue != this.filters['global'].value){
                this.prevFilterValue = (this.filters['global'].value + '').trim();
                this.onFilter();
            }
        },
        onDateChange(){
            if(!this.loading){
                this.lazyParams.from_date = this.dateFrom;
                this.lazyParams.to_date = this.dateTo;
                this.getIndex();
            }
        },
        onInput() {
            if(!this.loading && this.filters['global'].value == ''){
                this.onFilter();
                this.prevFilterValue = '';
            }
        },
        onEnter(){
            if(!this.loading){
                this.prevFilterValue = (this.filters['global'].value + '').trim();
                this.onFilter();
            }
        },
        initFilters() {
            this.filters = {
                'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
            }
        },
        setExtrafilters(filtergroup, value) {
            let name = filtergroup.field;
            let type = filtergroup.type;
            if(value == 'all'){
                this.extraFilters[name] = null;
                const els = document.querySelectorAll('input[data-field="'+name+'"]');
                els.forEach(el => el.checked = false);
            }
            else if(type == 'radio'){
                this.extraFilters[name] = '' + value;
            }
            else{
                let values = this.extraFilters[name] ? this.extraFilters[name].split(',') : [];
                let index = values.indexOf('' + value);
                if(index != -1){
                    values.splice(index, 1);
                }
                else{
                    values.push(value);
                }
                this.extraFilters[name] = values.join(',');
                const els = document.querySelectorAll('#filter-'+name+'-all');
                els.forEach(el => el.checked = values.length == 0);
            }
            this.getIndexEmployees();
        },
        getIndex() {
            this.loading = true;
            if(this.$route.name === 'employees' || (this.$route.name === 'companies' && store.getters.getCurrentCustomerId) ){
                this.getIndexEmployees();
                return;
            }
            if(window.location.search.includes('audit-trail') && !this.prevFilterValue){
                let searchData = decodeURIComponent(window.location.search.split('audit-trail=')[1]);
                this.filters['global'].value = searchData;
                this.prevFilterValue = searchData;
                this.onFilter();
                return;
            }
            if(this.$route.name === "show_employee_audit"){
                this.lazyParams.employee_id = this.$route.params.id;
            }
            
            this.items = this.itemService.index();
            this.item = {}
            this.itemService.index(this.page, {
                lazyEvent: JSON.stringify(this.lazyParams)
            }).then(response => {
                this.items = response.data;
                this.loading = false;
            }).catch(error => {
                console.log('error', error)
                // Zonder melding bleef de lijst hier eindeloos laden.
                this.loading = false;
                this.toastError(error, 'De lijst kon niet worden opgehaald.');
            })
        },
        getIndexEmployees(fromState = null) {
            // IHR-161. Dit overzicht wordt gerenderd voordat App.vue klaar is met
            // isLoggedIn -> customer -> getCompanies -> setCompany. Vlak na een verse
            // login zijn klant en bedrijf dus nog null en ging hier
            // GET /api/nmbrs/soap/null/employee?company_id=null de deur uit. De 404
            // die dat oplevert viel in de .catch hieronder en toonde de melding
            // "probleem bij NMBRS", terwijl er niets met NMBRS aan de hand was en de
            // lijst een seconde later gewoon laadde.
            //
            // Niet ophalen dus, en loading op true laten staan: dat is ook de
            // beginwaarde van de component, het houdt de filter- en sorteerhandlers
            // geblokkeerd en het toont een spinner in plaats van een lege tabel.
            // Het echte ophalen volgt vanzelf, want zodra setCompany() rond is klikt
            // setEmployeeOverview() in App.vue op #inv_button en komen we hier terug
            // met de goede ids.
            const customerId = store.getters.getCurrentCustomerId;
            const companyId = store.getters.getCurrentCompanyId;
            if(!customerId || (this.$route.name === 'employees' && !companyId)){
                this.loading = true;
                return;
            }

            this.items = {};
            this.item = {};
            var storedEmployeeOverviewData = this.$parent.$parent.$parent.storedEmployeeOverviewData;
            if(storedEmployeeOverviewData && fromState && (fromState.meta.title == "Edit Employee" || fromState.meta.title == "Employee")){
                this.page = storedEmployeeOverviewData.page;
                this.lazyParams.filters.global.value = storedEmployeeOverviewData.filter;
                this.lazyParams.sortField = storedEmployeeOverviewData.sortField;
                this.lazyParams.sortOrder = storedEmployeeOverviewData.sortOrder;
                this.$refs.dt.$refs.paginator.d_first = (storedEmployeeOverviewData.page - 1) * 20;
                this.$refs.dt.$refs.paginator.$forceUpdate();
            }
            const indexFilters = {...this.extraFilters};
            if(indexFilters.employee_status_id){
                indexFilters.employee_status_id = indexFilters.employee_status_id.replace('4', '4,5,6,10,11');
            }
            const pageNumber = this.page;
            this.itemService.indexByCompany({'customer_id': store.getters.getCurrentCustomerId, 'company_id': store.getters.getCurrentCompanyId}, 
                                             this.$route.name === 'companies' ? { lazyEvent: JSON.stringify(this.lazyParams)} : this.lazyParams.filters.global.value,
                                             this.lazyParams.sortField, 
                                             this.lazyParams.sortOrder,
                                             pageNumber, 
                                             indexFilters)
              .then(response => {
                this.items = {
                    current_page: response.data.current_page,
                    data: response.data.data,
                    first_page_url: null,
                    from: response.data.from,
                    last_page: response.data.last_page,
                    last_page_url: null,
                    links: null,
                    next_page_url: null,
                    path: null,
                    per_page: response.data.per_page,
                    prev_page_url: null,
                    to: response.data.to,
                    total: response.data.total
                };
                this.loading = false;
                this.$parent.$parent.$parent.storedEmployeeOverviewData = {
                    page: pageNumber,
                    filter: this.lazyParams.filters.global.value,
                    sortField: this.lazyParams.sortField,
                    sortOrder: this.lazyParams.sortOrder
                };
            }).catch(error => {
                console.log('error', error)
                // Hier stond voor elke fout "probleem bij NMBRS", ook voor een 404
                // of een fout van onze eigen server. toastError zegt dat alleen
                // nog als het antwoord echt van NMBRS komt. De lijst stopt met
                // laden, zodat zoeken of sorteren het opnieuw kan proberen.
                this.loading = false;
                this.toastError(error, 'De lijst kon niet worden opgehaald.');
            })
        },
        resetFilters(){
            this.lazyParams.filters.global.value = '';
            this.extraFilters.employee_status_id = null;
            const els = document.querySelectorAll('input[data-field="employee_status_id"]');
            els.forEach(el => el.checked = false);
            document.querySelector('#filter-employee_status_id-all').checked = true;
        },
        addItem() {
            this.itemLoading = false;
            this.itemFormRef.reset();
            this.item = this.itemFormRef.getData();
            this.isCopying = false;
        },
        copyItem(item) {
            this.itemLoading = true;

            this.itemService.show(item.id).then(response => {
                this.itemLoading = false;
                this.itemFormRef.reset();
                this.item = this.itemFormRef.getData();
                this.item.isCopy = true;
                let data = response.data;
                data.file_info = [];
                if(data.start_date && data.end_date){
                    data.start_date = moment().quarter(moment().quarter() + 1).startOf('quarter').format('YYYY-MM-DD');
                    data.end_date = moment().quarter(moment().quarter() + 1).endOf('quarter').format('YYYY-MM-DD');
                }
                delete data.finalized;
                delete data.id;
                data.number = '';
                this.itemFormRef.setData(data);
                this.isCopying = true;
            }).catch(error => {
                this.toastError(error)
                console.log('error', error) // create notification-toaster for user error
            })
        },
        editItem(item, direct = false, type = null) {
            if(direct) {
                this.itemLoading = false;
                this.item = item;
                this.item.isReminder = type == 'reminder';
                this.item.endEmployemnt = type == 'endemployment';
                this.item.wontBeEmployed = type == 'wontbeemployed';
                this.itemFormRef.setData(item);
                this.isMail = true;
                return;
            }
            
            this.itemLoading = true;
            this.itemFormRef.reset();
            this.isCopying = false;
            
            this.itemService.show(item.id).then(response => {
                this.itemLoading = false;
                this.item = response.data
                this.itemFormRef.setData(response.data);
            }).catch(error => {
                this.toastError(error)
                console.log('error', error) // create notification-toaster for user error
            })
        },
        delItem(item, fromEmployees = false) {
            this.item = {...item};
            if(fromEmployees){
                this.item.employee_name = item.first_name + ' ' + item.last_name.replace('*', '');
            }
        },
        downloadPDF(item) {
            this.item = {...item};
            this.itemService.downloadPDF(this.item.id).then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", this.item.number + ".pdf");
                document.body.appendChild(link);
                link.click();
            }).catch(error => {
                this.toastError(error)
            })

        },
        downloadTestPDF() {
            this.itemService.downloadTestPDF().then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "test.pdf");
                document.body.appendChild(link);
                link.click();
            }).catch(error => {
                this.toastError(error)
            })

        },
        save() {
            let validate = this.itemFormRef.validate();
            if(!validate) return false;
            let item = this.itemFormRef.getData();
            
            // Een tweede klik op Opslaan terwijl het verzoek loopt maakte het item
            // twee keer aan. De knop gaat nu ook uit, via :bezig op FormPopup.
            const bestaand = this.item && this.item.id;
            const verzoek = metRem(this, 'isSaving', () => bestaand ? this.itemService.update(item) : this.itemService.store(item));
            if(!verzoek) return false;
            verzoek.then(() => {
                //this.itemFormRef.reset();
                this.getIndex();
                document.querySelector("#modal-close-button").click();
            }).catch(error => {
                this.toastError(error)
                console.log('error', error) // create notification-toaster for user error
            })
            
        },
        del() {
            const verzoek = metRem(this, 'isDeleting', () => this.itemService.delete(this.item.id));
            if(!verzoek) return;
            verzoek.then(() => {
                this.getIndex();
                document.querySelector("#deleteModal .btn-close").click();
            }).catch(error => {
                this.toastError(error)
                console.log('error', error) // create notification-toaster for user error
            })
            
        },
        setSavedData(data){
            this.savedData = data;
            this.$forceUpdate();
        },
        setHref(mode, data, fromNMRS = false){
            let id = data.external_id ? data.external_id : (data.id ? data.id : data.employee_id);
            if(data.is_external && (typeof data.external_id == 'undefined' || !data.external_id)){
                id = data.employee_id;
            }

            if(data.amount_of_contracts){
                window.employmentData = {
                    employed_since: data.employed_since,
                    amount_of_contracts: data.amount_of_contracts
                }
            }
            else{
                window.employmentData = undefined;
            }
            
            if(mode == 0){
                // Zonder lokale contractregel bestaat data.contract.id niet en klapte
                // dit op undefined (IHR-164). Dat trof medewerkers die op "wacht op
                // ondertekenen" staan zonder eigen contractrij; die tonen sinds de
                // statusfusie hun echte status en krijgen daardoor pas sinds 24-09
                // dit menu-item te zien.
                //
                // Terugvallen op `id` is hier geen noodgreep maar de juiste bron:
                // NewEmployee.vue kiest zelf op `id > 99999` tussen het NMBRS-nummer
                // (showFromNMBRS) en een lokaal contract-id, en alle 66 getroffen
                // medewerkers hebben een NMBRS-nummer ruim boven die grens. Het is
                // ook exact wat de knop "Nieuw contract genereren" al doet via
                // fromNMRS.
                return router.push({ name: 'edit_employee_main', params: { id: (fromNMRS || !data.contract) ? id : data.contract.id } });
            }
            if(mode == 1){
                return router.push({ name: 'edit_employee_personalia', params: { id: id } });
            }
            if(mode == 5){
                // Alleen meegeven wat er is. Bij een medewerker die alleen in NMBRS
                // bestaat zijn data.id en data.employee_id allebei leeg, en dan kwam
                // hier letterlijk oldId=undefined in de URL te staan. NewEmployee.vue
                // leest die parameter en doet er employeeService.show() mee, waarna de
                // backend findOrFail('undefined') doet en de gebruiker de melding
                // "No query results for model [App\Models\Employee] undefined" krijgt.
                // Gevonden door Jordy op 01-10-2026 bij Autotest de Wit.
                return router.push({
                    name: 'edit_employee_personalia',
                    params: { id: id },
                    query: queryVoorNawWijziging(data)
                });
            }
            id = data.external_id ? data.external_id : (data.contract ? data.contract.id : data.employee_id);
            if(mode == 2){
                return router.push({ name: 'edit_employee_profession', params: { id: id } });
            }
            if(mode == 3){
                return router.push({ name: 'edit_employee_contract', params: { id: data.contract ? data.contract.id : data.employee_id } });
            }
            if(mode == 4){
                return router.push({ name: 'edit_employee_salary', params: { id: id } });
            }
            if(mode == 6){
                return router.push({ name: 'edit_employee_extension', params: { id: id } });
            }
            if(mode == 7){
                if(data.is_external && (typeof data.external_id == 'undefined' || !data.external_id)){
                    id = data.employee_id;
                }
                return router.push({ name: 'employee_exit', params: { id: id } });
            }
            return '#';
        },
        sync(data){
            // Dit schrijft de medewerker en het contract naar NMBRS en duurt
            // seconden. Het menu-item is een link en kan dus niet uit; zonder rem
            // startte elke klik een nieuwe export, en er was geen bevestiging
            // zoals bij de andere acties in dit menu.
            if(this.isSyncing){
                return this.$toast.info('Er loopt al een synchronisatie met NMBRS. Een moment geduld.');
            }
            const employeeName = data.first_name + ' ' + data.last_name.replace('*', '');
            if(!confirm("Weet je zeker dat je de gegevens van " + employeeName + " naar NMBRS wilt sturen?")) return;

            console.log("sync", data.contract.id, store.getters.getCurrentCustomerId);
            metRem(this, 'isSyncing', () => this.itemService.sync(data.contract.id, store.getters.getCurrentCustomerId)).then(response => {
                console.log('response', response);
                const el = document.getElementById('inv_button');
                if(el) el.click();
            }).catch(error => {
                if (error.response) {
                    // The request was made and the server responded with a status code
                    // that falls out of the range of 2xx
                    console.log(error.response.data);
                    console.log(error.response.status);
                    console.log(error.response.headers);
                    this.toastError(error)
                }
                else 
                {    
                    // Geen antwoord: een time-out of een weggevallen verbinding.
                    // Dat ging alleen naar de console, de gebruiker zag niets.
                    console.log('error', error.toJSON ? error.toJSON() : error);
                    this.toastError(error)
                }
                                
            })
        },
        sendSignRequest(data){
            let email = data.email;
            if(data.employee_status_id == 4){
                let company = this.$parent.$parent.$parent.companies.find(company => company.id == data.company_id);
                if(company){
                    email = company.representative_email;
                }
            }
            if(this.isSendingSignRequest){
                return this.$toast.info('Er wordt al een Signrequest verstuurd. Een moment geduld.');
            }
            if(confirm("Weet je zeker dat je een Signrequest wilt versuren naar " + email + "?")){
                metRem(this, 'isSendingSignRequest', () => this.itemService.signrequest(data.contract.id)).then(response => {
                    this.$toast.success('Signrequest verstuurd')
                }).catch(error => {
                    this.toastError(error)
                    console.log('error', error)
                })
            }
        }, 
        sendFinalizationRequest(data){
            if(this.isFinalizing){
                return this.$toast.info('Er wordt al een contract afgerond. Een moment geduld.');
            }
            const employeeName = data.first_name + ' ' + data.last_name.replace('*', '');
            if(confirm("Weet je zeker dat je " + employeeName + " in dienst wil laten worden?")){
                // Niet meer this.itemService.delete(data.id). Bij een medewerker die
                // wij alleen als archiefrij kennen is data.id leeg (die regel komt uit
                // de NMBRS-lus van getEmployees en heeft alleen employee_id, het
                // NMBRS-nummer), en dan ging er letterlijk DELETE employee/undefined
                // uit met "No query results for model [App\Models\Employee] undefined"
                // op het scherm. Juist bij die medewerkers is deze knop bedoeld: de *
                // achter de naam hieronder wordt er niet voor niets afgehaald.
                //
                // Het NMBRS-nummer mag niet als id meegaan, want de backend doet daar
                // findOrFail() op onze primaire sleutel op; dan rondt nummer 1378064
                // de medewerker met ons id 1378064 af. Daarom gaat het als external_id
                // naar een eigen endpoint. Zie IHR-182.
                const payload = sleutelVoorAfrondenBuitenSysteem(data, store.getters.getCurrentCompanyId);
                if(!payload){
                    return this.$toast.error('Deze medewerker heeft geen nummer waarmee hij af te ronden is.');
                }

                metRem(this, 'isFinalizing', () => employeeService.afrondenBuitenSysteem(payload)).then(response => {
                    // Het bericht komt van de server en de toast rendert HTML.
                    this.$toast.success(alsHtml([(response.data && response.data.message) || 'Medewerker is nu in dienst']))
                    this.getIndex()
                }).catch(error => {
                    this.toastError(error)
                    console.log('error', error)
                })
            }
        },
        setAuditTrail(data){
            location.href = location.origin + '/logs?audit-trail=' + encodeURIComponent(data.first_name + ' ' + data.last_name.replace('*', ''));
        },
        setDatePickerActive(e){
            e.target.type = 'date';
        },
        setDatePickerInctive(e){
            if(!e.target.value){
                e.target.type = 'text';
            }
        },
        onrowclick(e){
            if(document.getElementById('employee-overview') && e.data.contract){
                this.$router.push({ name: 'show_employee_main', params: { id: e.data.contract.id } });
            }
            else if(document.getElementById('log-overview') && e.data.user_agent){
                document.querySelector("#log-opener").click();
                this.editItem(e.data);
            }
        }
    },
    created() {
        this.initFilters();
    },
    mounted() {
        this.lazyParams = {
          first: 0,
          rows: this.$refs.dt.rows,
          sortField: this.sort,
          sortOrder: this.sortOrder,
          filters: this.filters,
          route: this.$route.name
        }
        if(this.$route.name === 'employees'){
            window.setTimeout(() => {
                if(!this.loading && !this.items.data){
                    this.getIndexEmployees();
                }
            }, 100);
        }
        else{
            this.getIndex();
        }
    }
}
</script>

<style scoped>

.dropdown-menu {
    inset: 0px 25px auto auto !important;
}

.dropdown-item {
    cursor: pointer;
}

</style>
